import client from "./client";

export const permissionsApi = {
  getRoleMatrix: () => client.get("/permissions/roles"),
  updateRolePermission: (roleName: string, feature: string, enabled: boolean) =>
    client.put(`/permissions/roles/${roleName}/${feature}`, { enabled }),

  getDataGroups: () => client.get("/permissions/data-groups"),
  createDataGroup: (payload: Record<string, unknown>) => client.post("/permissions/data-groups", payload),
  updateDataGroup: (id: string, payload: Record<string, unknown>) => client.put(`/permissions/data-groups/${id}`, payload),
  deleteDataGroup: (id: string) => client.delete(`/permissions/data-groups/${id}`),

  getDatasources: () => client.get("/permissions/datasources"),
};
